import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";

class Products extends Component {
  state = {
    products: [],
    loading: true,
  };

  componentDidMount() {
    this.fetchProducts();
  }

  fetchProducts = async () => {
    try {
      const res = await axios.get("/products"); // API endpoint
      if (res.data.status === "success") {
        this.setState({ products: res.data.data, loading: false });
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to fetch products", "error");
    }
  };

  handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      try {
        const res = await axios.delete(`/products/${id}`);
        if (res.data.status === "success") {
          Swal.fire("Deleted!", res.data.message, "success");
          this.fetchProducts();
        }
      } catch (err) {
        Swal.fire("Error", "Failed to delete product", "error");
      }
    }
  };

  render() {
    const { products, loading } = this.state;
    const baseUrl = axios.defaults.baseURL.replace("/api", "");
    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-lg-12">
              <div className="card shadow-none">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <ul className="breadcrumb mb-0">
                    <li className="breadcrumb-item">Products</li>
                    <li className="breadcrumb-item">List</li>
                  </ul>
                  <Link to="/admin/product_form" className="btn btn-light-warning">
                    New Product
                  </Link>
                </div>

                <div className="card-body shadow border-0">
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Category</th>
                          <th>Sub Category</th>
                          <th>Child Category</th>
                          <th>Brand</th>
                          <th>Tags</th>
                          <th>Name</th>
                          <th>Image</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={10} className="text-center">
                              Loading...
                            </td>
                          </tr>
                        ) : products.length === 0 ? (
                          <tr>
                            <td colSpan={10} className="text-center">
                              No Products Found
                            </td>
                          </tr>
                        ) : (
                          products.map((p, index) => (
                            <tr key={p.id}>
                              <td>{index + 1}</td>
                              <td>{p.category_name || "N/A"}</td>
                              <td>{p.sub_category_name || "N/A"}</td>
                              <td>{p.child_category_name || "N/A"}</td>
                              <td>{p.brand_name || "N/A"}</td>
                              <td>{p.tag_names || "N/A"}</td>
                              <td>{p.product_name}</td>

                              <td>
                                {p.product_img ? (
                                  <img
                                    src={`${baseUrl}/uploads/products/${p.product_img}`}
                                    alt="img"
                                    style={{ width: "50px", height: "50px", borderRadius: "6px" }}
                                  />
                                ) : (
                                  "No Image"
                                )}
                              </td>

                             
                              <td>
                                {p.product_state === "1" ? "Active" : "Inactive"}
                              </td>
                              <td>
                                <Link
                                  to={`/admin/product_edit/${p.id}`}
                                  className="btn btn-sm btn-light-success me-1"
                                >
                                  <i className="ph ph-note-pencil align-middle" />
                                </Link>
                                <button
                                  onClick={() => this.handleDelete(p.id)}
                                  className="btn btn-sm btn-light-danger"
                                >
                                  <i className="ph ph-trash align-middle" />
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Products;
